var _path, _path2, _ellipse, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4327 10.5V6.97378C11.4327 6.73396 11.3896 6.49609 11.3054 6.27153L10.5094 4.14888C10.363 3.75857 9.9899 3.5 9.57306 3.5H4.34795C3.9311 3.5 3.55798 3.75857 3.41162 4.14888L2.61562 6.27153C2.53142 6.49609 2.48828 6.73396 2.48828 6.97378V10.5M11.4327 10.5V11.5892C11.4327 11.632 11.398 11.6667 11.3553 11.6667V11.6667C11.3125 11.6667 11.2778 11.632 11.2778 11.5892V10.5M11.4327 10.5H11.2778M2.48828 10.5V11.5497C2.48828 11.6143 2.54065 11.6667 2.60525 11.6667V11.6667C2.66985 11.6667 2.72222 11.6143 2.72222 11.5497V10.5M2.48828 10.5H2.72222M2.72222 10.5H11.2778",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 6.61133H11.2778",
    stroke: "#798293",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.51114,
    cy: 8.63297,
    rx: 0.622222,
    ry: 0.622222,
    fill: "#798293"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.17776,
    cy: 8.63297,
    r: 0.622222,
    fill: "#798293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCar);
export default __webpack_public_path__ + "static/media/p_car.37e0d6abe004f4088009ba579efa1cb9.svg";
export { ForwardRef as ReactComponent };